export default {
    SignUp: "Sign Up",
    ForgottenPassword: "Forgotten Password",
};